module.exports = [
  '다오',
  '마리드',
  '배찌',
  '디지니',
  '우니',
  '에띠',
  '케피',
  '로두마니',
  '모스',
  '마리오',
  '루이지',
  '피치',
  '로젤리나',
  '쿠파',
  '키노피오',
  '와리오',
  '사일러스',
  '헤카림',
  '진',
  '가렌',
  '갈리오',
  '갱플랭크',
  '그라가스',
  '그레이브즈',
  '나르',
  '나미',
  '나서스',
  '노틸러스',
  '녹턴',
  '누누',
  '니달리',
  '다리우스',
  '다이애나',
  '드레이븐',
  '라이즈',
  '라칸',
  '람머스',
  '럭스',
  '럼블',
  '레넥톤',
  '레오나',
  '렉사이',
  '렐',
  '그웬',
  '렝가',
  '루시안',
  '룰루',
  '르블랑',
  '리 신',
  '리븐',
  '바드',
  '미스 포츈',
  '문도 박사',
  '마스터 이',
  '마오카이',
  '말파이트',
  '볼리베어',
  '브라움',
  '모르가나',
  '모데카이저',
  '브랜드',
  '블리츠크랭크',
  '비에고',
  '빅토르',
  '사미라',
  '사이온',
  '샤코',
  '세나',
  '세라핀',
  '세주아니',
  '세트',
  '아리',
  '아무무',
  '신드라',
  '시비르',
  '신 짜오',
  '스카너',
  '아이번',
  '아지르',
  '소라카',
  '소나',
  '쉔',
  '애니비아',
  '겐지',
  '둠피스트',
  '리퍼',
  '맥크리',
  '메이',
  '바스티온',
  '솜브라',
  '시메트라',
  '애쉬',
  '에코',
  '위도우메이커',
  '정크랫',
  '토르비욘',
  '트레이서',
  '파라',
  '한조',
  '라인하르트',
  '레킹볼',
  '로드호그',
  '시그마',
  '오리사',
  '윈스턴',
  '자리야',
  '루시우',
  '메르시',
  '모이라',
  '바티스트',
  '브리기테',
  '아나',
  '젠야타',
  '레이스',
  '방갈로르',
  '미라지',
  '옥테인',
  '레버넌트',
  '호라이즌',
  '퓨즈',
  '블러드하운드',
  '패스파인더',
  '크립토',
  '발키리',
  '라이프라인',
  '로바',
  '지브롤터',
  '코스틱',
  '왓슨',
  '램파트',
  '소닉',
  '테일즈',
  '스랄',
  '제이나',
  '가로쉬',
  '데스윙',
  '발리라',
  '마이에브',
  '우서',
  '렉사르',
  '실바나스',
  '말퓨리온',
  '굴단',
  '느조스',
  '메디브',
  '안두인',
  '일리단',
  '하이머딩거',
  '피즈',
  '피오라',
  '피들스틱',
  '판테온',
  '파이크',
  '티모',
  '트위치',
  '트위스티드 페이트',
  '트린다미어',
  '트리스타나',
  '트런들',
  '고든',
  '탐켄치',
  '탈리야',
  '탈론',
  '타릭',
  '킨드레드',
  '키아나',
  '클레드',
  '퀸',
  '코르키',
  '코그모',
  '케일',
  '케인',
  '케이틀린',
  '케넨',
  '칼리스타',
  '카타리나',
  '카직스',
  '카이사',
  '카시오페아',
  '카서스',
  '카사딘',
  '카밀',
  '카르마',
  '초가스',
  '징크스',
  '질리언',
  '직스',
  '진',
  '조이',
  '제이스',
  '제라스',
  '제드',
  '잭스',
  '잔나',
  '자크',
  '자르반',
  '일라오이',
  '이즈리얼',
  '이블린',
  '이렐리아',
  '유미',
  '워윅',
  '우르곳',
  '우디르',
  '요릭',
  '요네',
  '올라프',
  '오른',
  '오리아나',
  '오공',
  '엘리스',
  '에코',
  '야스오',
  '애쉬',
  '애니비아',
  '애니',
  '알리스타',
  '아펠리오스',
  '아우렐리온 솔',
  '아트록스',
  '아칼리',
  '아크샨',
  '마린',
  '파이어뱃',
  '벌쳐',
  '시즈탱크',
  '배틀크루져',
  '저글링',
  '히드라리스크',
  '울트라리스크',
  '럴커',
  '메딕',
  '고스트',
  '하이템플러',
  '다크템플러',
  '리버',
  '옵저버',
  '스카웃',
  '캐리어',
  '질럿',
  '아칸',
  '다크아칸',
  '드라군',
  '커세어',
  '뮤탈리스크',
  '스커지',
  '디바우러',
  '가디언',
  '공허충',
  '말자하',
  '진',
  '카즈야',
  '헤이하치',
  '에디',
  '알리사',
  '간류',
  '니나',
  '안나',
  '드라구노프',
  '리리',
  '리로이 젠킨스',
  '브라이언',
  '스티브 폭스',
  '샤오유',
  '아머킹',
  '요시미츠',
  '자피나',
  '쿠니미츠',
  '클라우디오',
  '화랑',
  '아이작',
];
